
import AttorneyHubAPIService from "_shared/_api/attorney-hub-api-service";
import AssistantAPICommand from "ai-assistant/_api/commands/assistant-api-command";
import AssistantResponse from "ai-assistant/assistant-response";
import axios, { AxiosHeaders } from "axios";
import Session from "users/__session/session";

export default class AIAssistantAPIService {

  private readonly authHeaders: AxiosHeaders = new AxiosHeaders();

  private headersWithJson(): AxiosHeaders {
    return this.authHeaders.concat({ 'Content-Type': 'application/json' });
  }

  constructor(session: Readonly<Session>) {
    if (!session.authToken?.value) {
      throw new Error("Session must have an authToken to create a AIAssistantAPIService");
    }
    this.authHeaders.set(
      "Authorization",
      `Bearer ${session.authToken.value}`
    );
  }

  async sendMessage(
    message: string,
    previousResponseId?: string,
    currentRoute?: string,
  ): Promise<AssistantResponse> {
    try {
      const url = new URL(
        "/ai-assistant",
        AttorneyHubAPIService.apiBaseUrl
      );

      const payload = new AssistantAPICommand();
      payload.message = message;
      payload.previousResponseId = previousResponseId;
      payload.currentRoute = currentRoute;

      const response = await axios.post(
        url.toString(),
        payload,
        { headers: this.headersWithJson() }
      );
      return AssistantResponse.fromJSON(response.data);
    } catch (error) {
      throw new AIAssistantAPIServiceError(
        "sendMessage",
        error
      );
    }
  }
}

export class AIAssistantAPIServiceError extends Error {
  method: string;
  error: unknown;

  constructor(method: string, error: unknown) {
    super(`Error calling ${method}: ${error}`);
    this.method = method;
    this.error = error;
  }
}
